import { toCamel } from './../Util/SnakeCamelUtil';
import { DateUtil } from './../Util/DateUtil';
import { HealthInsureDAO } from './../DAO/HealthInsureDAO';
import { BaseService } from './BaseService';
import  heic2any from 'heic2any';
import imageCompression from 'browser-image-compression';

/**
 * HealthInsureService
 *
 * 保険証関連のサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class HealthInsureService extends BaseService {


	/**
	 * getHealthInsure
	 * 保険証の簡易データ一覧取得
	 * @returns 保険証の簡易データ
	 */
	public async getHealthInsure() {

		// 保険証の簡易データ取得
		const dao = new HealthInsureDAO(this as BaseService);
		const ret = await dao.getHealthInsure();

		// キャメルに変換
		const arr = this.obj2Array(toCamel(ret));
		const result: any = {};

		// 名称でチェックして、ファイルの前後を決定する
		arr.forEach(val => {
			if (val.displayName.includes('_01')) {
				result.front = val;
			} else {
				result.back = val;
			}
		});

		return result;

	}

	/**
	 * uploadHealthInsure
	 * 保険証のアップロード
	 * @param uploadFile 保険証の写真ファイル
	 * @returns アップロード後の保存データ
	 */
	public async uploadHealthInsure(uploadFile: any) {

		// ファイルアップロードを行う
		const dao = new HealthInsureDAO(this as BaseService);
		const ret = {
			front: null,
			back: null
		};

		// UIの関係上、１つのFileListで送るのが手間なので２回呼ぶ。
		// 表面の処理
		if (uploadFile.front) {
			// HEIC形式がアップロードされた場合に変換する
			if (uploadFile.front.type === 'image/heic') {
				uploadFile.front = await this.convertHeic2Jpeg(uploadFile.front);
			}
			// ファイルサイズが大きい場合に圧縮する
			uploadFile.front = await imageCompression(uploadFile.front, { maxSizeMB: 1, maxWidthOrHeight: 600 });
			// 表のアップロード
			ret.front = await dao.uploadHealthInsure('保険証_01', DateUtil.getNowDateString(), uploadFile.front);
		}
		// 裏面の処理
		if (uploadFile.back) {
			// HEIC形式がアップロードされた場合に変換する
			if (uploadFile.back.type === 'image/heic') {
				uploadFile.back = await this.convertHeic2Jpeg(uploadFile.back);
			}
			// ファイルサイズが大きい場合に圧縮する
			uploadFile.back = await imageCompression(uploadFile.back, { maxSizeMB: 1, maxWidthOrHeight: 600 });
			// 裏のアップロード
			ret.back = await dao.uploadHealthInsure('保険証_02', DateUtil.getNowDateString(), uploadFile.back);
		}

		return ret;

	}

	// 更新
	/**
	 * changeHealthInsure
	 * ファイルの更新を行う
	 * @param fileInfoId ファイルID
	 * @param displayName 表示名
	 * @param uploadFile アップロードファイル
	 * @returns アップロード後の保存データ
	 */
	public async changeHealthInsure(fileInfoId: number, displayName: string, uploadFile: any) {

		// ファイルサイズが大きい場合に圧縮する
		uploadFile = await imageCompression(uploadFile, { maxSizeMB: 1, maxWidthOrHeight: 600 });

		// ファイルを変更する
		const dao = new HealthInsureDAO(this as BaseService);
		const ret = await dao.changeHealthInsure(fileInfoId, displayName, DateUtil.getNowDateString(), uploadFile);

		return ret;

	}

	/**
	 * deleteHealthInsure
	 * アップロード済みのファイルを削除する
	 * @param fileInfoId ファイルID
	 */
	public async deleteHealthInsure(fileInfoId: number) {

		const dao = new HealthInsureDAO(this as BaseService);
		await dao.deleteHealthInsure(fileInfoId);


	}

	/**
	 * convertHeic2Jpeg
	 * アップロードファイルがHEIC形式の場合に、jpegに変換する
	 * 主にiPhone対応
	 * @param data Fileデータ
	 * @returns jpegに変換したファイルデータ
	 */
	private async convertHeic2Jpeg(data: File) {

		const name = data.name.substring(0, data.name.indexOf('.')) + '.jpeg';
		const conv = await heic2any({
			blob: data,
			toType: 'image/jpeg',
			quality: 0.5
		}) as Blob;

		return new File([conv], name, { type: 'image/jpeg' });

	}


}

